(function () {
  if (window.themeInventoryHydrator) {
    return;
  }

  const HYDRATED_EVENT = 'cart:inventory-hydrated';
  const variantCapsByHandle = new Map();
  const inflightByHandle = new Map();

  function shouldCap(variant) {
    return Boolean(
      variant &&
        variant.inventory_management === 'shopify' &&
        variant.inventory_policy === 'deny'
    );
  }

  function buildVariantMap(productData) {
    const map = new Map();
    if (!productData || !Array.isArray(productData.variants)) {
      return map;
    }
    productData.variants.forEach(function (variant) {
      if (!shouldCap(variant)) {
        return;
      }
      const qty = Number(variant.inventory_quantity);
      if (!Number.isFinite(qty)) {
        return;
      }
      map.set(String(variant.id), Math.max(0, qty));
    });
    return map;
  }

  function publishHydrated(handle, variantMap) {
    if (!window.themePubsub || typeof window.themePubsub.publish !== 'function') {
      return;
    }
    window.themePubsub.publish(HYDRATED_EVENT, {
      handle: handle,
      variantMap: variantMap
    });
  }

  function fetchVariantMap(handle) {
    if (variantCapsByHandle.has(handle)) {
      return Promise.resolve(variantCapsByHandle.get(handle));
    }
    const existing = inflightByHandle.get(handle);
    if (existing) {
      return existing.promise;
    }
    const controller = new AbortController();
    const promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: controller.signal
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        const map = buildVariantMap(data);
        variantCapsByHandle.set(handle, map);
        inflightByHandle.delete(handle);
        return map;
      })
      .catch(function (error) {
        inflightByHandle.delete(handle);
        if (error && error.name === 'AbortError') {
          return null;
        }
        return new Map();
      });
    inflightByHandle.set(handle, { promise: promise, controller: controller });
    return promise;
  }

  function abortInflight() {
    inflightByHandle.forEach(function (entry) {
      if (entry && entry.controller) {
        entry.controller.abort();
      }
    });
    inflightByHandle.clear();
  }

  function collectHandles(scope) {
    const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    const elements = root.querySelectorAll('quantity-input[data-product-handle]');
    const handles = new Set();
    elements.forEach(function (element) {
      const handle = element.dataset.productHandle;
      if (handle) {
        handles.add(handle);
      }
    });
    return handles;
  }

  function hydrate(root) {
    const handles = collectHandles(root);
    if (handles.size === 0) {
      return;
    }
    handles.forEach(function (handle) {
      if (variantCapsByHandle.has(handle)) {
        publishHydrated(handle, variantCapsByHandle.get(handle));
        return;
      }
      fetchVariantMap(handle).then(function (variantMap) {
        if (variantMap) {
          publishHydrated(handle, variantMap);
        }
      });
    });
  }

  window.themeInventoryHydrator = {
    hydrate: hydrate,
    abortInflight: abortInflight
  };

  if (window.themePubsub && typeof window.themePubsub.subscribe === 'function') {
    window.themePubsub.subscribe('cart:drawer:opened', function (payload) {
      hydrate((payload && payload.dialog) || document);
    });
    window.themePubsub.subscribe('cart:updated', function () {
      hydrate(document);
    });
    window.themePubsub.subscribe('cart:drawer:closed', function () {
      abortInflight();
    });
  }
})();
